<template>
  <div :class="{'progress-mask': progressInfo.hasMask}">
    <div
      ref="dialogEl"
      :class="['progress-box', {'progress-container': progressInfo.isFake}]"
    >
      <div class="progress-content">
        <div
          v-if="progressInfo.op_type"
          class="progress-file-icon"
        />
        <div class="progress-txt">
          <div class="main-txt">
            {{ progressInfo.mainTxt || $t('请稍后...') }}
          </div>
          <div class="minor-txt">
            {{ progressInfo.minorTxt || '' }}
          </div>
        </div>
      </div>
      <el-progress
        :percentage="progress"
        :show-text="!progressInfo.hideText"
        color="#0A64FA"
      />
    </div>
  </div>
</template>

<script>
import _$ from 'js/api/getdata.js'
import { getWidthOrHeight } from 'js/util/util.js'

export default {
  props: {
    /* params：@task_id：操作id(真进度条必填)
                       @mainTxt：主文本
                       @minorTxt：次文本
                       @op_type：操作类型（按照设计图目前仅解压操作进度条有图标）
                       @hideText: 是否隐藏进度条文字内容，默认不隐藏
                       @fakeProgress: 是否时假进度条，这样task_id不必填
            */
    progressData: Object,
  },
  data() {
    return {
      param: {},
      left: 0,
      top: 0,
      progress: 0,
      timer: {},
      step: 0.1, // 是否让进度条慢下来
    }
  },
  computed: {
    progressInfo() {
      return this.progressData
    },
  },
  mounted() {
    // this.setPos() //用css替代js
    this.listenEvent()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    setPos() {
      const $dialog = this.$refs.dialogEl
      const elemH = getWidthOrHeight($dialog, 'height')
      const elemW = getWidthOrHeight($dialog, 'width')
      const winH = window.innerHeight || document.documentElement.clientHeight
      const winW = window.innerWidth || document.documentElement.clientWidth
      this.left = (winW - elemW) / 2
      this.top = (winH - elemH) / 2
    },
    listenEvent() {
      const vm = this
      clearInterval(this.timer)
      if (this.progressInfo.isFake) { // 假进度条
        this.timer = setInterval(() => {
          vm.makeProgress()
        }, 100)
      } else {
        this.timer = setInterval(() => {
          vm.listenPort()
        }, 300)
      }
    },
    makeProgress() {
      if (this.progress >= 99) {
        clearInterval(this.timer)
      } else if (this.progress >= 80) {
        this.progress += (1 * this.step)
      } else {
        this.progress++
      }
    },
    listenPort() {
      const data = {
        task_id: this.progressInfo.task_id,
      }
      _$.getData('asyncQuery', data).then((res) => {
        if (res.data.is_finish === 'true') {
          this.progress = parseInt(res.data.progress)
          this.$emit('changeProgressStatus', this.progress)
          if (res.data.state !== '200') {
            window.$toast.simpleShow(res.data.message, 'warn')
          }
          clearInterval(this.timer)
        } else {
          this.progress = parseInt(res.data.progress)
        }
      }).catch((error) => {
        clearInterval(this.timer)
        const err = error.response.data
        this.$emit('showTips', err.message, 'error')
      })
    },
  },
}
</script>

<style lang="less">
.progress-mask{
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 998;
}
.progress-box{
  width: 390px;
  height: 140px;
  padding: 28px;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 0 7px #ccc;
  background: #ffffff;
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  margin-left: -195px;
  margin-top: -70px;
  .progress-content{
    height: 80px;
    .progress-file-icon{
      width: 27px;
      height: 27px;
      float: left;
      border: 1px solid #ccc;
      display: inline-block;
      margin-top: 2px;
    }
    .progress-txt{
      display: inline-block;
      margin-left: 8px;
      .main-txt{
        font-size: 14px;
      }
      .minor-txt{
        margin-top: 12px;
        font-size: 14px;
        color: #67707C;
      }
    }
  }
}
.progress-container{
  background: #FFFFFF;
  box-shadow: 0 4px 12px 0 rgba(0,0,0,0.20);
  border-radius: 4px;
  height: auto;
  width: 380px;
  padding: 26px 39px 28px 39px;
  margin-left: -190px;
  margin-top: -50px;
  .progress-content{
    height: auto;
    margin-bottom: 20px;
    .progress-txt{
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #4D5365;
      width: 100%;
      text-align: center;
      line-height: 20px;
      height: 20px;
      margin: auto;
      .main-txt{
        word-break: break-word;
      }
    }
  }
}
</style>
